import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.75, delay, ease: EASE }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ num, label }) => (
  <div className="flex items-center gap-4" data-testid={`chapter-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
    <span className="font-mono text-xs font-medium tracking-[0.25em] text-brand-600">{num}</span>
    <span className="h-px flex-1 bg-neutral-200" />
    <span className="font-mono text-xs uppercase tracking-[0.25em] text-neutral-400">{label}</span>
  </div>
);
